import { useThemeSlice } from "./components/ui/StatusBadge.jsx";
import { useActiveRoute, useMainRouteLoading, usePendingRoute, useSbState, useSetSbState } from "./logic/stores/navigationStore.js";
import { Sidebar } from "./components/layout/Sidebar.jsx";
import { RoutePageSkeleton } from "./components/skeletons/RoutePageSkeleton.jsx";
import { Ico } from "./components/icons/icons.jsx";
import { UsersPage } from "./pages/Users/UsersPage.jsx";
import { AccountsPage } from "./pages/Accounts/AccountsPage.jsx";
import { DevicesPage } from "./pages/Devices/DevicesPage.jsx";
import { DeviceTypesPage } from "./pages/DeviceTypes/DeviceTypesPage.jsx";
import { SimsPage } from "./pages/Sims/SimsPage.jsx";
import { SimTypesPage } from "./pages/SimTypes/SimTypesPage.jsx";
import { IcpPage } from "./pages/Icp/IcpPage.jsx";
import { ReportBuilderPage } from "./pages/ReportBuilder/ReportBuilderPage.jsx";

function RoutedPage({ active }) {
  switch (active) {
    case "acc-ov":
      return <AccountsPage />;
    case "user-ov":
      return <UsersPage />;
    case "icp-ov":
      return <IcpPage />;
    case "dev-ov":
      return <DevicesPage />;
    case "devtype-ov":
      return <DeviceTypesPage />;
    case "sim-ov":
      return <SimsPage />;
    case "simtype-ov":
      return <SimTypesPage />;
    case "rpt-bld":
      return <ReportBuilderPage />;
    default:
      return <AccountsPage />;
  }
}

export function AppLayout() {
  const { c, typography, chrome } = useThemeSlice();
  const active = useActiveRoute();
  const sbState = useSbState();
  const setSbState = useSetSbState();
  const mainRouteLoading = useMainRouteLoading();
  const pendingRoute = usePendingRoute();
  const isClosed = sbState === "closed";

  return (
    <div style={{ display: "flex", height: "100vh", fontFamily: typography.fontFamily, background: c.bg, color: c.text, fontSize: 13 }}>
      <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
        <Sidebar />
        <main style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column", background: c.bg }}>
          {isClosed && (
            <button
              type="button"
              onClick={() => setSbState("open")}
              onMouseEnter={(e) => (e.currentTarget.style.background = c.hover)}
              onMouseLeave={(e) => (e.currentTarget.style.background = c.card)}
              style={{
                position: "fixed",
                left: 12,
                top: 12,
                zIndex: 50,
                width: 34,
                height: 34,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: c.card,
                border: `1px solid ${c.cardBdr}`,
                borderRadius: chrome.radiusMd,
                cursor: "pointer",
                color: c.mid,
                boxShadow: chrome.shadowSm,
              }}
            >
              {Ico.panelLeft}
            </button>
          )}
          <div className="nemo-main-route" style={{ position: "relative", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }} aria-busy={mainRouteLoading}>
            {mainRouteLoading ? <RoutePageSkeleton /> : <RoutedPage active={pendingRoute ?? active} />}
          </div>
        </main>
      </div>
    </div>
  );
}
